<div class="choose-ab-test-group-wrapper">
  <pdq-dropdown
    class="dropdown"
    mode="default"
    title="Choose A/B test group"
    width="fit-content"
    [border]="false"
    [options]="results"
    placeholder="N/A"
    [defaultOption]="defaultOption"
    buttonFontSize="16"
    [showSelectUnselectOptions]="true"
    tooltip="Assign a group to this A/B test to easily find it in analytics"
    (onChange)="changeABTestGroupDropdown($event)"
    [disabled]="disabled">
  </pdq-dropdown>
  <pdq-button
    class="btn-add-group"
    variant="secondary"
    label="Add new group"
    (onClick)="createABTestGroupClick($event)"
    [disabled]="disabled">
  </pdq-button>
</div>
